import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {DxTextBoxComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {User} from '../../../../../shared/models/fusion-auth';
import {FusionAuthService} from '../../../../../shared/services/fusion-auth';
import {DOMService, ScreenService} from '../../../../../shared/services/general';
import {Physician} from '../../../models/order-entry/physician';
import {PhysicianService} from '../../../services/physician.service';
import * as Sentry from "@sentry/angular-ivy";

@Component({
  selector: 'app-physician-selector-dialog',
  templateUrl: './physician-selector-dialog.component.html',
  styleUrls: ['./physician-selector-dialog.component.scss'],
})
export class PhysicianSelectorDialogComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public popupVisible = false;
  @Input() public patientClientId = -1;
  @Output() public closeEvent = new EventEmitter();

  public physicianDialogForm: UntypedFormGroup;
  @ViewChild('lastNameTextBox', {static: false}) public lastNameTextBox?: DxTextBoxComponent;
  public isLoading = false;
  // @ts-ignore
  public searchedPhysicians: BehaviorSubject<DataSource> = new BehaviorSubject(null);
  public user: User;
  public isPhone: boolean = false;
  public isTablet: boolean = false;
  public isPhoneLandscape: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private fb: UntypedFormBuilder, public physicianService: PhysicianService,
              private domService: DOMService,
              private fusionAuthService: FusionAuthService, private screen: ScreenService) {
    this.physicianDialogForm = this.fb.group({
      lastName: [''],
      firstName: [''],
      npi: [''],
      sameAsClient: [false],
    });

    this.user = fusionAuthService.Profile;
  }

  public ngOnInit(): void {
    if (this.screen) {
      this.isPhone = this.screen.sizes['screen-x-small'];
      this.isPhoneLandscape = this.screen.sizes['screen-small'];
      this.isTablet = this.screen.sizes['screen-tablet'];
      this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
        this.isPhone = this.screen.sizes['screen-x-small'];
        this.isPhoneLandscape = this.screen.sizes['screen-small'];
        this.isTablet = this.screen.sizes['screen-tablet'];
      });
    }
  }

  public ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    if (changes.popupVisible) {
      if (changes.popupVisible.currentValue) {
        this.submitSearch();
      }
    }

    const body = this.domService.getBody();
    if (changes.popupVisible && changes.popupVisible.currentValue) {
      if (body) {
        body.style.overflow = 'hidden';
      }
      setTimeout(() => {
        this.lastNameTextBox?.instance.instance().focus();
      }, 1000);
    } else {
      if (body) {
        body.style.overflow = 'auto';
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  public keyEvent(event: KeyboardEvent) {
    try {
      if (event.key === 'Enter' && this.popupVisible) {
        if (this.physicianDialogForm.valid) {
          this.submitSearch();
        }
      }
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  public rowClick(e: any) {
    if (e.rowType === 'data') {
      this.resultSelected(e.data);
    }
  }

  public close(): void {
    this.physicianDialogForm.reset();
    // @ts-ignore
    this.searchedPhysicians.next(undefined);
    this.closeEvent.emit();
  }

  public resultSelected(physician: Physician): void {
    if (physician) {
      this.physicianDialogForm.reset();
      // @ts-ignore
      this.searchedPhysicians.next(undefined);
      this.closeEvent.emit(physician);
    }
  }

  public submitSearch() {
    if (this.physicianDialogForm.valid) {
      const physician = {
        lastName: this.physicianDialogForm.value.lastName,
        firstName: this.physicianDialogForm.value.firstName,
        npi: this.physicianDialogForm.value.npi,
        patientClientId: this.physicianDialogForm.value.sameAsClient ? this.patientClientId : -1,
      };
      this.isLoading = true;

      /*const role = this.user.registrations[0].roles[0];
      const clientIds = role === 'Client Basic' || role === 'Client Admin' ? this.user.data.clients : [];*/

      this.searchedPhysicians.next(new DataSource({
        store: this.physicianService.searchCustomStore(
          physician.firstName,
          physician.lastName,
          physician.npi,
          physician.patientClientId,
          [],
          this.searchedPhysicians
        )
      }));
      this.isLoading = false;
    }
  }

  public ready(e: any) {
    this.lastNameTextBox = e.component;
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
